export const LIST_BOOKID_COURSE = 'LIST_BOOKID_COURSE';
export const CREATE_BOOKID_COURSE = 'CREATE_BOOKID_COURSE';
export const SHOW_BOOKID_COURSE = 'SHOW_BOOKID_COURSE';
export const UPDATE_BOOKID_COURSE = 'UPDATE_BOOKID_COURSE';
export const DELETE_BOOKID_COURSE = 'DELETE_BOOKID_COURSE';
export const CHECK_ALL = 'CHECK_ALL';
export const CHECK_INPUT_ITEM = 'CHECK_INPUT_ITEM';
export const DATA_REMOVE_BOOKID_COURSE = 'DATA_REMOVE_BOOKID_COURSE';
export const LIST_BOOKID_COURSE_CATEGORY = 'LIST_BOOKID_COURSE_CATEGORY';
export const BOOKID_COURSE_UPDATE_RELATE = 'BOOKID_COURSE_UPDATE_RELATE';
export const UPDATE_META_DATA_BOOKID_COURSE = 'UPDATE_META_DATA_BOOKID_COURSE';
export const ADD_CHAPTER = 'ADD_CHAPTER';
export const UPDATE_GROUP_CHAPTER = 'UPDATE_GROUP_CHAPTER';
export const REMOVE_CHAPTER = 'REMOVE_CHAPTER';
export const PAGING_BOOKID_COURSE = 'PAGING_BOOKID_COURSE';